/** The close cross of Sheet and Dialog, painted like the kit's other icons: an image in the secondary ink on a 16 px box. See docs/design/kit-requests.md: when icons/set.ts has `close`, this file goes. */
import { paint } from "./icons/paint";
import { INK } from "./icons/palette";

const SRC = paint({ w: 16, h: 16, layers: [{ d: "M18 6 6 18M6 6l12 12", stroke: INK, width: 1.5, cap: "round", join: "round" }] });

export function CloseIcon() {
  return <img src={SRC} width={16} height={16} alt="" className="block size-4 shrink-0" />;
}
